// Pam Beesly — almoxarife virtual do módulo Administrativo. Cuida do
// estoque de consumíveis (marcos, EPIs, uniformes), alerta quando algo
// está acabando e ajuda a registrar compras.
import { useState } from 'react';

export default function PamConfig() {
  const [aba, setAba] = useState<'sobre' | 'tools'>('sobre');

  return (
    <div style={{ padding: '20px 28px', maxWidth: 900, margin: '0 auto' }}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16, gap: 14 }}>
        <span style={{
          width: 40, height: 40, borderRadius: 10, background: '#7C3AED',
          color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 18, fontWeight: 700,
        }}>P</span>
        <div>
          <h2 style={{ margin: 0, fontSize: 18, color: '#020D7F' }}>Pam Beesly — almoxarife virtual</h2>
          <div style={{ fontSize: 11, color: '#888' }}>
            Cuida do estoque de consumíveis e alerta quando algo está acabando
          </div>
        </div>
      </div>

      <div className="tab-bar-h" style={{ display: 'flex', gap: 22, marginBottom: 14, borderBottom: '0.5px solid #e0e0e0' }}>
        {[
          { id: 'sobre', label: 'Sobre' },
          { id: 'tools', label: 'Ferramentas' },
        ].map(t => (
          <button key={t.id} onClick={() => setAba(t.id as any)}
            style={{ fontSize: 13, background: 'none', border: 'none', cursor: 'pointer',
              color: aba === t.id ? '#7C3AED' : '#6A7092',
              fontWeight: aba === t.id ? 600 : 400,
              padding: '8px 0', borderBottom: `2px solid ${aba === t.id ? '#7C3AED' : 'transparent'}` }}>
            {t.label}
          </button>
        ))}
      </div>

      {aba === 'sobre' && (
        <div style={{ background: '#fff', border: '0.5px solid #e0e0e0',
          borderRadius: 5, padding: 18, lineHeight: 1.6, fontSize: 13 }}>
          <p>
            <strong>Pam Beesly</strong> é o agente do módulo Administrativo. Cuida do
            almoxarifado virtualmente — sabe o que tem, o que está acabando e o que
            precisa ser comprado.
          </p>
          <p>Ela é proativa pra:</p>
          <ul>
            <li>Avisar quando um material caiu abaixo do mínimo cadastrado</li>
            <li>Sugerir compra (com fornecedor padrão e custo unitário)</li>
            <li>Registrar saídas de estoque vinculadas a contratos/atividades</li>
            <li>Responder "quanto temos de X?", "compramos quando X?"</li>
          </ul>
          <p style={{ color: '#666', fontSize: 12, fontStyle: 'italic' }}>
            Use o botão flutuante <strong>P</strong> no canto da tela pra conversar com a Pam.
          </p>
        </div>
      )}

      {aba === 'tools' && (
        <div style={{ background: '#fff', border: '0.5px solid #e0e0e0',
          borderRadius: 5, padding: 18, fontSize: 12, lineHeight: 1.7 }}>
          <h3 style={{ margin: '0 0 12px', fontSize: 13, color: '#020D7F' }}>
            Ferramentas (read-only)
          </h3>
          <ul style={{ margin: 0, paddingLeft: 18 }}>
            <li><code>admin_listar_materiais</code> — busca materiais por categoria/nome/baixo estoque</li>
            <li><code>admin_dashboard_estoque</code> — KPIs, alertas, movimentações recentes</li>
            <li><code>admin_listar_movimentacoes</code> — histórico de um material/contrato</li>
          </ul>
          <h3 style={{ margin: '16px 0 12px', fontSize: 13, color: '#020D7F' }}>
            Ferramentas (escrita — vira card de aprovação)
          </h3>
          <ul style={{ margin: 0, paddingLeft: 18 }}>
            <li><code>admin_registrar_movimentacao</code> — entrada (compra) / saída (uso) / ajuste (inventário)</li>
            <li><code>admin_criar_material</code> — cadastra novo material no estoque</li>
          </ul>
        </div>
      )}
    </div>
  );
}
